<template>
  <span :class="`badge badge-pill badge-${getColor(env)}`">{{ env }} </span>
</template>

<script>
export default {
  props: {
    env: { required: true, type: String },
  },
  data() {
    return {
      colors: {
        prod: "danger",
        review: "primary-light",
        stage: "info",
        dev: "primary",
      },
    }
  },
  methods: {
    getColor(env) {
      const key = env.split("-")[0]
      return this.colors[key]
    },
  },
}
</script>

<style></style>
